import React, { useState, useEffect } from "react";

import "./BugTable.css";

import {
  getBugSummary,
  getBugDetails,
  deleteBugById,
  getBugsByProjId,
  getSubtasksByProjectName,
  getBugsBySubtask,
  modifyBug,
} from "../../services/homeService";

import EmptyState from "../../Components/EmptyState/EmptyState";

import { useDispatch, useSelector } from "react-redux";
import SubtaskSelectionDialog from "../../Components/Popup/SubtaskSelectionDialog";


import {
  setBugSummary,
  setIsBugSummaryModal,
  setIsBugDashboard,
  setBugViewMode,
  setCurrentBugDetails,
  setIsBugPage,
  setSelectedProjectBugs,
  setLoading,
  setSelectedProject
} from "../../store/slice/bugSlice";
import { useNavigate, useParams } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import viewIcon from "../../assets/icons/visibility.svg";
import deleteIcon from "../../assets/icons/deleteIcon_1.svg";
import FreeSoloCreateOption from "../../Components/SearchDropdown/index";
import axios from "axios";
import { getCookie, getUserData } from "../../services/utils";
import loginData from "./userLoginIds.json";

const BugTable = ({ bugsList, loading: externalLoading }) => {
  const [bugDetails, setBugDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubtaskDialogOpen, setIsSubtaskDialogOpen] = useState(false);
  const [hasSubtasks, setHasSubtasks] = useState(false);
  
  const { bugViewMode, currentBugDetails, selectedProject } = useSelector(
    (state) => {
      return state.bugDetails;
    }
  );
  const { selectedClient } = useSelector((state) => {
    return state.clientDetails;
  });
  const dispatch = useDispatch();

  const { clientId, projectId, bugId } = useParams();
  const currentPath = window.location.pathname;
  const isSubtaskView = window.location.pathname.includes('/subtask/');
  const isBugView = window.location.pathname.includes('/bug/');
  const urlParts = window.location.pathname.split('/');
  const subtaskIdFromUrl = isSubtaskView ? urlParts[urlParts.indexOf('subtask') + 1] : null;
  const subtaskNameFromState = window.history.state?.state?.subtaskName || 'Subtask';
    
  const navigate = useNavigate();
  const [value, setValue] = useState(null);
  const options = bugsList?.map((project) => ({
    title: project.bugSummary.name,
  }));
  let count = 0;
  
  // Check if project has subtasks when component mounts
  useEffect(() => {
    checkProjectHasSubtasks();
  }, [selectedProject]);
  
  // Load bugs on component mount and when URL changes
  useEffect(() => {
    
    
    const loadBugsBasedOnURL = async () => {
      // Always set loading on page load or reload
      dispatch(setLoading(true));
      
      try {
        console.log("isCurrentSubtaskView:", isSubtaskView, "currentSubtaskId:", subtaskIdFromUrl, "projectId:", projectId, "isBugView:", isBugView);
        if (isSubtaskView && subtaskIdFromUrl) {
          console.log("Loading bugs for subtask:", subtaskIdFromUrl);
          // We're in a subtask view, load bugs for this specific subtask
          const subtaskBugs = await getBugsBySubtask(subtaskIdFromUrl);
          console.log(`Loaded ${subtaskBugs?.length || 0} bugs for subtask ID ${subtaskIdFromUrl}`);
          dispatch(setSelectedProjectBugs(subtaskBugs));
        } else if (projectId && !isBugView) {
          console.log("Loading bugs for project:", projectId);
          // We're in a regular project view, load all bugs for this project
          const projectBugs = await getBugsByProjId(projectId);
          console.log(`Loaded ${projectBugs?.length || 0} bugs for project ID ${projectId}`);
          dispatch(setSelectedProjectBugs(projectBugs));
        } else {
          dispatch(setSelectedProjectBugs([]));
        }
      } catch (error) {
        console.error("Error loading bugs:", error);
      } finally {
        dispatch(setLoading(false));
      }
    };
    
    loadBugsBasedOnURL();
  }, [projectId,isSubtaskView,subtaskIdFromUrl,isBugView]); // Only depend on projectId changes
  
  // Function to check if the project has subtasks
  const checkProjectHasSubtasks = async () => {
    if (selectedProject?.name) {
      try {
        const subtasks = await getSubtasksByProjectName(selectedProject.name);
        
        // Check for active subtasks (not "Closed" or "Done")
        const activeSubtasks = (subtasks || []).filter(subtask => 
          subtask.status !== "Closed" && subtask.status !== "Done"
        );
        
        setHasSubtasks(activeSubtasks.length > 0);
        console.log(`Project ${selectedProject.name} has ${activeSubtasks.length} active subtasks`);
      } catch (error) {
        console.error("Error checking for subtasks:", error);
        setHasSubtasks(false);
      }
    }
  };

  const BugListHeaders = [
    { header: "S. No.", key: "index" },

    { header: "Bug Title", key: "bugTitle" },

    { header: "Created By", key: "createdBy" },

    // { header: "Type", key: "type" },

    { header: "Severity", key: "severity" },

    { header: "Bug Type", key: "bugType" },

    { header: "Status", key: "status" },

    { header: "Actions", key: "actions" },
  ];

  const email = getCookie("email");
  const isApprovedUser = loginData.login.includes(email);
  console.log("isApprovedUser", isApprovedUser);

  const bugCount = bugsList.length;


  const getClassByStatus = (status) => {
    switch (status) {
      case "Open":
        return "yellow-text";

      case "In Progress":
        return "blue-text";

      case "Reopened":
        return "violet-text";

      case "Resolved":
        return "red-text";

      case "Close":
        return "green-text";

      default:
        return "";
    }
  };

  const handleDashboardBtn = () => {
    // Removed permission check to allow all users to access dashboard
    dispatch(setIsBugDashboard(true));
    const state = {
      clientName: selectedClient.label,
      projectName: selectedProject?.name,
      guid: selectedProject?.guid,
    };
    navigate(`/client/${clientId}/project/${projectId}/dashboard`, {
      state,
    });
  };

  const getBugSummaryApi = async () => {
    try {
      const resp = await getBugSummary();
      dispatch(setBugSummary(resp));
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  };

  const getBugDetailsApi = async (id) => {
    try {
      const resp = await getBugDetails(id);
      setBugDetails(resp);
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  };

  const handleBugTypeChange = async (bugItem, newBugType) => {
    try {
      const isDeleted = newBugType === "Invalid";
      
      // Prepare the payload with all required fields
      const payload = {
        id: 0,
        project: {
          id: bugItem.project?.id,
          name: bugItem.project?.name,
          clientId: bugItem.project?.clientId,
        },
        feature: {
          id: bugItem.feature?.id,
          name: bugItem.feature?.name,
        },
        pageTitle: bugItem.pageTitle || "",
        subSection: bugItem.subSection || "",
        description: bugItem.description || "",
        comments: bugItem.comments || "",
        createdBy: bugItem.createdBy,
        stepsToReproduce: bugItem.stepsToReproduce || "",
        instances: bugItem.instances || "",
        actualResult: bugItem.actualResult || "",
        expectedResult: bugItem.expectedResult || "",
        alteredCode: bugItem.alteredCode || "",
        suggestedCode: bugItem.suggestedCode || "",
        bugSummary: {
          id: bugItem.bugSummary?.id,
          name: bugItem.bugSummary?.name,
          rationale: bugItem.bugSummary?.rationale,
          recommendations: bugItem.bugSummary?.recommendations,
          workingExamples: bugItem.bugSummary?.workingExamples,
          bugType: bugItem.bugSummary?.bugType,
          wcagGuidelineReferenceNo: bugItem.bugSummary?.wcagGuidelineReferenceNo,
          wcagPrinciples: bugItem.bugSummary?.wcagPrinciples,
          wcagVersion: bugItem.bugSummary?.wcagVersion,
          wcagLevel: bugItem.bugSummary?.wcagLevel,
          wcagReference: bugItem.bugSummary?.wcagReference,
          type: bugItem.bugSummary?.type,
          severity: bugItem.bugSummary?.severity,
          isApproved: bugItem.bugSummary?.isApproved || false,
        },
        status: {
          id: bugItem.status?.id,
          value: bugItem.status?.value,
        },
        method: {
          id: bugItem.method?.id,
          value: bugItem.method?.value,
        },
        testingEnvironments: bugItem.testingEnvironments || [],
        isApproved: bugItem.isApproved || false,
        isDeleted: isDeleted,
        screenshots: [],
      };

      await modifyBug(payload, bugItem.id);
      
      // Update the bug in the Redux store without reloading
      const updatedBugs = bugsList.map(bug => 
        bug.id === bugItem.id 
          ? { ...bug, isDeleted: isDeleted }
          : bug
      );
      
      dispatch(setSelectedProjectBugs(updatedBugs));
    } catch (error) {
      console.error("Error updating bug type:", error);
      alert("Failed to update bug type. Please try again.");
    }
  };

  const handleDeleteBug = async (item) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this bug?"
    );
    if (confirmation) {
      const { id, project } = item;
      
      // Determine which delete endpoint to use based on user approval status and bug ownership
      // Case 1: Non-approved user - always permanent delete
      // Case 2: Approved user deleting their own bug - permanent delete
      // Case 3: Approved user deleting someone else's bug - regular delete
      const isOwnBug = item?.createdBy === email;
      const isPermanentDelete = true
      
      try {
        await deleteBugById(id, isPermanentDelete);
        dispatch(setLoading(true));
        
        // Check if we're in a subtask view
        const isSubtaskView = window.location.pathname.includes('/subtask/');
        const urlParts = window.location.pathname.split('/');
        const subtaskIdFromUrl = isSubtaskView ? urlParts[urlParts.indexOf('subtask') + 1] : null;
        
        let res;
        if (isSubtaskView && subtaskIdFromUrl) {
          // We're in a subtask view, reload bugs for this specific subtask
          res = await getBugsBySubtask(subtaskIdFromUrl);
        } else {
          // We're in a regular project view, reload all bugs for this project
          res = await getBugsByProjId(project?.id);
        }
        
        dispatch(setSelectedProjectBugs(res));
      } catch (error) {
        console.error("Error deleting bug:", error);
        alert("Failed to delete the bug. Please try again.");
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const handleViewBug = (bugdetails) => {
    // Permission check removed to allow all users to view bug details
    
    dispatch(setBugViewMode(true));
    dispatch(setIsBugSummaryModal(true));
    getBugDetailsApi(bugdetails.id);
    
    // Prepare navigation state using component-level variables
    const state = {
      clientName: selectedClient.label,
      projectName: selectedProject?.name,
      guid: selectedProject?.guid,
    };
    
    // If we're in a subtask view, add subtask info to the state
    if (isSubtaskView && subtaskIdFromUrl) {
      const subtaskState = window.history.state?.state || {};
      state.subtaskId = subtaskIdFromUrl;
      state.subtaskName = subtaskState.subtaskName || subtaskNameFromState;
      state.subtaskSummary = subtaskState.subtaskSummary || '';
    }
    
    navigate(`/client/${clientId}/project/${projectId}/bug/${bugdetails.id}`, {
      state,
    });
  };

  const handleAddBugTableBtn = () => {
    // Permission check removed to allow all users to add bugs
    
    if (isSubtaskView && subtaskIdFromUrl) {
      // We're already in a subtask view, create bug directly for this subtask
      dispatch(setIsBugSummaryModal(true));
      getBugSummaryApi();
      
      // Extract subtask info from URL and state
      const subtaskState = window.history.state?.state || {};
      
      const state = {
        clientName: selectedClient.label,
        projectName: selectedProject?.name,
        guid: selectedProject?.guid,
        subtaskId: subtaskIdFromUrl,
        subtaskName: subtaskState.subtaskName || subtaskNameFromState || 'Unknown subtask',
        subtaskSummary: subtaskState.subtaskSummary || '',
        // Add flag to indicate this is a subtask bug creation
        isSubtaskBug: true
      };
      
      console.log("Creating bug directly for subtask:", subtaskIdFromUrl, state);
      
      // Navigate to add bug page with subtask info
      navigate(`/client/${clientId}/project/${projectId}/addBug`, {
        state,
      });
    }
    // If not in subtask view but project has subtasks, show dialog
    else if (hasSubtasks) {
      setIsSubtaskDialogOpen(true);
    } 
    // Default case: no subtasks or subtask dialog not needed
    else {
      dispatch(setIsBugSummaryModal(true));
      getBugSummaryApi();
      const state = {
        clientName: selectedClient.label,
        projectName: selectedProject?.name,
      };
      navigate(`/client/${clientId}/project/${projectId}/addBug`, {
        state,
      });
    }
  };
  
  // Handle subtask selection from the dialog
  const handleSubtaskSelect = async (subtask) => {
    // Get bug summary data for the bug creation form
    dispatch(setIsBugSummaryModal(true));
    await getBugSummaryApi();
    
    // Prepare state with selected subtask information for the bug creation page
    const state = {
      clientName: selectedClient.label,
      projectName: selectedProject?.name,
      guid: selectedProject?.guid,
      subtaskName: subtask.key,
      subtaskSummary: subtask.summary,
      subtaskId: subtask.id,
      // Add flag to indicate this is a subtask bug creation
      isSubtaskBug: true
    };
    
    // Set the current project in Redux
    dispatch(setSelectedProject({ id: projectId, name: selectedProject?.name }));
    
    // Navigate to the bug creation page with subtask information
    navigate(`/client/${clientId}/project/${projectId}/addBug`, {
      state,
    });
  };

  const csvData = (() => {
    const headers = ["Bug Title", "Type", "Severity", "WCAG", "Status"];
    const rows = bugsList.map((item) => [
      item.bugSummary.name,
      item.bugSummary.bugType,
      item.bugSummary.severity,
      item.bugSummary.wcagLevel,
      item?.status?.value,
      
    ]);
    return [headers, ...rows];
  })();

  const handleDownloadCSV = async () => {
    // Removed permission check to allow all users to download CSV
    try {
      const baseURL = process.env.REACT_APP_BUG_REPORTING_TOOL_URL;
      const response = await axios.get(
        `${baseURL}bug/getAllBugDetailsByProject/${selectedProject.id}/export`,
        {
          responseType: "blob", // Important for handling binary data
        }
      );

      // Extract project name from selected project
      const projectName = selectedProject.name;
      const prefix = projectName.split("_")[0];
      const csvName = `bug_details_${prefix}.csv`

      // Create a URL for the file and set it as a link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // You can set the filename here
      link.setAttribute("download", csvName);

      // Append to the document and click to start the download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const handleReviewProject = async () => {
    const state = {
      id: 0,
      name: `${selectedProject?.name}_review`,
      clientId: selectedClient.value,
      url: selectedProject?.url,
      userName: selectedProject?.userName,
      password: selectedProject?.password,
    }

    try{
      setIsLoading(true)
      // Check if review project already exists
      const checkResponse = await axios.get(`${process.env.REACT_APP_BUG_REPORTING_TOOL_URL}project/exists/${state.name}`);
      // const checkResponse = await axios.get(`http://localhost:8081/bugreportingtool-api/api/v1/project/exists/${state.name}`);
      const projectExists = checkResponse.data.exists;
      const reviewProjectId = checkResponse.data.projectId; 

      console.log('Project Exists:', projectExists);
      console.log('Review Project ID:', reviewProjectId);

      if (projectExists){
        const confirmOverride = window.confirm("A review project alreay exists. Do you want to replace it");

        if (confirmOverride){
          await axios.delete(`${process.env.REACT_APP_BUG_REPORTING_TOOL_URL}project/deleteProject/${reviewProjectId}`);
          // await axios.delete(`http://localhost:8081/bugreportingtool-api/api/v1/project/deleteProject/${reviewProjectId}`);
        }
        else{
          setIsLoading(false)
          return;
        }          
      }

      const response = await axios.post(`${process.env.REACT_APP_BUG_REPORTING_TOOL_URL}project/createReviewProject/${selectedProject?.id}`, state, {
      // const response = await axios.post(`http://localhost:8081/bugreportingtool-api/api/v1/project/createReviewProject/${selectedProject?.id}`, state, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setIsLoading(false)
      if (response.status === 200) {
        const newState = {
          clientName: selectedClient.label,
          guid: selectedProject?.guid,
          scrollToBottom: true,
        };
        navigate(`../client/${selectedClient.value}`, {
          state: newState,
        });
        alert("Review project created/updated successfully!");
      }

    }catch(error){
      setIsLoading(false)
      console.error("Error creating review project:", error.response || error.message);
      alert("Failed to create review project.");
    }
  }


 const userRole = getCookie('role')

 
  

  
  return  (
    <>
    {
      isLoading || externalLoading ? 
      <div className="loader">
        <CircularProgress />
      </div> : <> 
      {/* Subtask Selection Dialog */}
      <SubtaskSelectionDialog
        open={isSubtaskDialogOpen}
        handleClose={() => setIsSubtaskDialogOpen(false)}
        projectName={selectedProject?.name}
        projectId={projectId}
        clientId={clientId}
        onSubtaskSelect={handleSubtaskSelect}
      />
      <div className="buglist">
        <h2 className="tabletitle">
          {isSubtaskView 
            ? `Bug List - Subtask`
            : "Bug List"
          }
        </h2>
        
        <div style={{ width: "50%" }}>
          <FreeSoloCreateOption
            value={value}
            setValue={setValue}
            options={{ options }}
            width={"60%"}
            //  float={"right"}
            marginLeft={"175px"}
          />
        </div>
       
        {/* Show different buttons based on whether we're in subtask view or not */}
        <div style={{ display: "flex", gap: 10 }}>
          {isSubtaskView ? (
            /* For subtask view, only show the Add Bug button */
            <button 
              className="addbugBtn" 
              onClick={handleAddBugTableBtn}
              style={{
                opacity: 1,
                pointerEvents: "auto"
              }}
            >
              Add Bug
            </button>
          ) : (
            /* For regular project view, show all buttons */
            <>
              <button 
                disabled={userRole === 'CONTRACTOR' || !isApprovedUser || bugCount === 0 || isLoading} 
                className="dashboardBtn" 
                onClick={handleReviewProject}
              >
                Review
              </button>

              <button 
                disabled={userRole === 'CONTRACTOR'} 
                className="dashboardBtn" 
                onClick={handleDownloadCSV}
                style={{
                  opacity: 1,
                  pointerEvents: "auto"
                }}
              >
                CSV
              </button>
              <button 
                className="dashboardBtn" 
                onClick={handleDashboardBtn}
                style={{
                  opacity: 1,
                  pointerEvents: "auto"
                }}
              >
                Dashboard
              </button>
              <button 
                className="addbugBtn" 
                onClick={handleAddBugTableBtn}
                style={{
                  opacity: 1,
                  pointerEvents: "auto"
                }}
              >
                Add Bug
              </button>
            </>
          )}
        </div>
      </div>
      {bugsList && bugsList.length > 0 ? (
        <div className="bug-table">
          <table>
            <thead>
              <tr>
                {BugListHeaders.map((header, index) => {
                  return (
                    <th
                      className="thead-th"
                      key={index}
                      style={{
                        textAlign: header.header === "Bug Title" ? "left" : "",
                      }}
                    >
                      {header.header}
                    </th>
                  );
                })}
              </tr>
            </thead>

            <tbody>
              {bugsList.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "evenRow" : "oddRow"}
                    style={
                      value != null
                        ? {
                            display: item?.bugSummary?.name
                              ?.toLowerCase()
                              .includes(value?.title?.toLowerCase())
                              ? "table-row"
                              : "none",
                          }
                        : {}
                    }
                  >
                    <td>{index + 1}</td>

                    <td style={{ textAlign: "left" }}>
                      {item?.bugSummary?.name}
                    </td>
                    <td>
                      {item?.createdBy}
                    </td>

                    {/* <td>{item?.bugSummary?.bugType}</td> */}

                    <td>{item?.bugSummary?.severity}</td>

                    <td>
                      <select
                        className="status-drop"
                        value={item?.isDeleted ? "Invalid" : "Valid"}
                        disabled={userRole === 'CONTRACTOR'}
                        onChange={(e) => handleBugTypeChange(item, e.target.value)}
                        style={{
                          padding: "5px 10px",
                          borderRadius: "4px",
                          border: "1px solid #ddd",
                          backgroundColor: "#fff",
                          cursor: userRole === 'CONTRACTOR' ? 'not-allowed' : 'pointer',
                          fontSize: "14px",
                          fontWeight: 500,
                        }}
                      >
                        <option value="Valid">Valid</option>
                        <option value="Invalid">Invalid</option>
                      </select>
                    </td>

                    <td
                      className={getClassByStatus(item?.status?.value)}
                      style={{ fontWeight: 700 }}
                    >
                      {item?.status?.value}
                    </td>

                    <td>
                      <div style={{display: 'flex', justifyContent: 'center', gap: 10}}>
                      <img
                        src={viewIcon}
                        alt="view"
                        style={{ cursor: 'pointer', opacity: 1 }}
                        onClick={() => handleViewBug(item)}
                        title="View bug details"
                      />

                      <button
                        title="delete"
                        onClick={() => handleDeleteBug(item)}
                        className={`flex items-center justify-center`}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: 'pointer',
                          opacity: 1,
                        }}
                      >
                        <img
                          src={deleteIcon}
                          alt="delete"
                          style={{
                            marginBottom: -2,
                          }}
                        />
                      </button>
                      </div>
                     
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState
          text={isSubtaskView ? "This subtask has no reported bugs." : "This project has no reported bugs."}
          btnText="Add Bug"
          handleBtn={handleAddBugTableBtn}
        />
      )}
      {options.map((item, index) => {
        // Check if the title of the item includes the title from value object
        if (item.title.toLowerCase().includes(value?.title?.toLowerCase())) {
          count++;
        }
        // Return null as we only want to count and not render anything
        return null;
      })}
      {value?.title && count === 0 && (
        <div className="not-found">No Projects Found</div>
      )}
      </>
    }
    </>
  );
};

export default BugTable;
